var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilmmakersRoundel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 31.9995C64 45.9515 52.6888 57.2626 38.7368 57.2626C24.7848 57.2626 13.4736 45.9515 13.4736 31.9995C13.4736 18.0474 24.7848 6.73633 38.7368 6.73633C52.6888 6.73633 64 18.0474 64 31.9995Z",
    fill: "#A532FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6318 31.9995C60.6318 45.9515 49.3206 57.2626 35.3686 57.2626C21.4166 57.2626 10.1055 45.9515 10.1055 31.9995C10.1055 18.0474 21.4166 6.73633 35.3686 6.73633C49.3206 6.73633 60.6318 18.0474 60.6318 31.9995Z",
    fill: "#00CCE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5263 31.9995C50.5263 45.9515 39.2152 57.2626 25.2632 57.2626C11.3112 57.2626 0 45.9515 0 31.9995C0 18.0474 11.3112 6.73633 25.2632 6.73633C39.2152 6.73633 50.5263 18.0474 50.5263 31.9995Z",
    fill: "#FE5C53"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8945 31.9995C53.8945 45.9515 42.5833 57.2626 28.6313 57.2626C14.6793 57.2626 3.36816 45.9515 3.36816 31.9995C3.36816 18.0474 14.6793 6.73633 28.6313 6.73633C42.5833 6.73633 53.8945 18.0474 53.8945 31.9995Z",
    fill: "#FFD264"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2636 31.9995C57.2636 45.9515 45.9525 57.2626 32.0005 57.2626C18.0485 57.2626 6.7373 45.9515 6.7373 31.9995C6.7373 18.0474 18.0485 6.73633 32.0005 6.73633C45.9525 6.73633 57.2636 18.0474 57.2636 31.9995Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7477 31.9993C39.7477 36.2772 36.2782 39.7467 32.0003 39.7467C27.7224 39.7467 24.2529 36.2772 24.2529 31.9993C24.2529 27.7214 27.7224 24.252 32.0003 24.252C36.2782 24.252 39.7477 27.7214 39.7477 31.9993Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilmmakersRoundel);
export default __webpack_public_path__ + "static/media/filmmakers-roundel.99b4c444c9332c0aa5ebd9d28ca6d791.svg";
export { ForwardRef as ReactComponent };